"use client";

import SearchDialog from "./SearchDialog";
import { useSearchStore } from "@/app/lib/searchStore";

export default function SearchDialogWrapper() {
  const open = useSearchStore((state) => state.open);

  return <>{open && <SearchDialog />}</>;
}
